<template>
  <header class="learn-guide-header" :class="{'transparent':bgTransparent}">
    <img src="../../assets/img/learningGuidePage/white_back.png" alt="" @click="goBack()" v-if="bgTransparent">
    <img v-else src="../../assets/img/header/back-button.png" alt="" @click="goBack()">
    <span class="title">导学页</span>
    <div class="right"></div>
  </header>
</template>

<script>
export default {
  props: {
    bgTransparent: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped lang="scss">
.learn-guide-header {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100px;
  color: #000;
  background: white;

  .title {
    color: #333;
    font-weight: 400;
    font-size: 36px;
    line-height: 50px;
  }

  img {
    width: 43px;
    height: 43px;
    margin-left: 31px;
  }

  .right {
    width: 43px;
    margin-right: 31px;
  }
}
.transparent{
  background: transparent;
  .title{
    color: white;
  }
}
</style>
